module.exports = __webpack_public_path__ + "img/slide_1.6b009668.jpg";